import "./instrument"
import {ThemeProvider, CssBaseline} from "@mui/material"
import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import {theme} from "./theme/theme"
import "./index.css"
import {Provider} from "react-redux"
import {store} from "./store/store"

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Provider store={store}>
                <App />
            </Provider>
        </ThemeProvider>
    </React.StrictMode>
)
